'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuantityAdjuster = function () {
  function QuantityAdjuster(el) {
    var listeners = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    (0, _classCallCheck3.default)(this, QuantityAdjuster);

    this.listeners = listeners;

    this.className = 'js-QuantityAdjuster';
    this.context = { context: el };
    this.els = {
      el: el,
      controls: {
        minus: (0, _functional.getElement)('.' + this.className + '_Control-minus', this.context),
        plus: (0, _functional.getElement)('.' + this.className + '_Control-plus', this.context)
      },
      input: (0, _functional.getElement)('.' + this.className + '_Input', this.context),
      variantQty: (0, _functional.getElement)('.' + this.className + '_Input', this.context).getAttribute('data-variant-quantity-in-stock')
    };
    this._value = parseInt(this.els.input.value, 10);

    this.setupListeners();
  }

  (0, _createClass3.default)(QuantityAdjuster, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      this.els.controls.minus.addEventListener('click', function () {
        _this.ensureQuantityIntegrity();

        _this.value -= 1;

        _this.els.input.classList.add('qty-Adjuster_Input-feedback');
        setTimeout(function () {
          _this.els.input.classList.remove('qty-Adjuster_Input-feedback');
        }, 800);
      });
      this.els.controls.plus.addEventListener('click', function () {
        _this.ensureQuantityIntegrity();

        _this.value += 1;

        _this.els.input.classList.add('qty-Adjuster_Input-feedback');
        setTimeout(function () {
          _this.els.input.classList.remove('qty-Adjuster_Input-feedback');
        }, 800);
      });
      this.els.input.addEventListener('input', function () {
        var value = parseInt(_this.els.input.value, 10);

        if (isNaN(value) === false) {
          _this.value = value;
        }
      });
      this.els.input.addEventListener('change', function () {
        var value = _this.els.input.value;

        if (value === '') {
          _this.value = 1;
        }
      });
    }
  }, {
    key: 'ensureQuantityIntegrity',
    value: function ensureQuantityIntegrity() {
      if (this.value !== parseInt(this.els.input.value, 10)) {
        this.value = parseInt(this.els.input.value, 10);
      }
    }
  }, {
    key: 'emit',
    value: function emit(value) {
      this.listeners.forEach(function (listener) {
        return listener(value);
      });
    }
  }, {
    key: 'value',
    get: function get() {
      return this._value;
    },
    set: function set(val) {
      this._value = val < 1 ? 1 : val;

      this.els.input.value = this._value;

      this._value === 1 ? this.els.controls.minus.setAttribute('disabled', null) : this.els.controls.minus.removeAttribute('disabled');

      this.emit(val);

      if (this.els.variantQty === null) return;

      this._value >= this.els.variantQty ? this.els.controls.plus.setAttribute('disabled', null) : this.els.controls.plus.removeAttribute('disabled');
    }
  }]);
  return QuantityAdjuster;
}();

exports.default = QuantityAdjuster;